export default __webpack_public_path__ + "static/pspo2logo-8d643cfa767e6ab4fed64083c7511a17.png";